import React from "react"
import api from "src/api"

export function useGetData() {
  const [dataItems, setDataItems] = React.useState([])
  const [isLoading, setIsLoading] = React.useState(false)
  const [typeOptions, setTypeOptions] = React.useState([])

  React.useEffect(() => {
    getItems()
    getTypeOptions()
  }, [])

  function getTypeOptions() {
    api.get("support-channels/types").then(({ data }) => {
      setTypeOptions(
        data.items.map((item) => ({
          label: `${item.name} (${item.slug})`,
          value: item.slug,
        }))
      )
    })
  }

  function getItems() {
    setIsLoading(true)
    api
      .get("support-channels")
      .then(({ data }) => setDataItems(getFormattedItems(data.items)))
      .finally(() => setIsLoading(false))
  }

  function getFormattedItems(items) {
    return items.map((item) => ({
      ...item,
      key: item.id,
      nameRu: item.name?.find((el) => el.language === "ru")?.content ?? "",
    }))
  }

  return {
    dataItems,
    isLoading,
    refetch: () => getItems(),
    options: { typeOptions },
  }
}
